import axiosInstance from "@/api/axios-instance";

export async function updatePrescriptionTags({
  prescriptionId,
  tags,
}: {
  prescriptionId: string;
  tags: string[];
}) {
  const normalizedId = String(prescriptionId || "").trim().split("/")[0];

  try {
    const response = await axiosInstance.post(`/prescriptions/${normalizedId}/tags`, {
      tags,
    });

    if (!response.status.toString().startsWith("2")) {
      throw new Error(response.data?.error || "Failed to update prescription tags");
    }

    return response.data;
  } catch (error: any) {
    // Backward compatibility: some backend instances may only expose POST /prescriptions/:id
    if (error?.response?.status === 404) {
      try {
        const fallbackResponse = await axiosInstance.post(
          `/prescriptions/${normalizedId}`,
          { tags },
        );

        if (!fallbackResponse.status.toString().startsWith("2")) {
          throw new Error(
            fallbackResponse.data?.error || "Failed to update prescription tags",
          );
        }

        return fallbackResponse.data;
      } catch (fallbackError: any) {
        console.error("Error updating prescription tags (fallback):", fallbackError);
        if (fallbackError.response) {
          throw new Error(
            fallbackError.response.data?.message ||
              fallbackError.response.data?.error ||
              "Failed to update doctor decision. Please restart backend server and try again.",
          );
        }
        throw fallbackError;
      }
    }

    console.error("Error updating prescription tags:", error);
    if (error.response) {
      throw new Error(
        error.response.data?.message ||
          error.response.data?.error ||
          "Failed to update prescription tags",
      );
    }
    throw error;
  }
}
